import { useCallback, useState } from "react";
import { useProductCheckout } from "../components/ProductCheckout/ProductCheckoutContext";
import { CustomerInfoSchema } from "../components/ProductCheckout/customerInfoFormSchema";

export function useCustomerInfoStep() {
  const { state, setCustomerInfo, setOrderNotes, nextStep } =
    useProductCheckout();
  const { customerInfo, orderNotes, cartItems } = state;

  const [errors, setErrors] = useState<Record<string, string>>({});

  const validate = useCallback((): boolean => {
    const newErrors: Record<string, string> = {};

    const customerResult = CustomerInfoSchema.safeParse(customerInfo);
    if (!customerResult.success) {
      customerResult.error.issues.forEach((issue) => {
        const key = issue.path[0];
        if (typeof key === "string" && !newErrors[key]) {
          newErrors[key] = issue.message;
        }
      });
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  }, [customerInfo]);

  const handleContinue = useCallback(() => {
    if (validate()) {
      nextStep();
    }
  }, [validate, nextStep]);

  return {
    customerInfo,
    orderNotes,
    cartItems,
    errors,
    setCustomerInfo,
    setOrderNotes,
    handleContinue,
  };
}
